import { emitDocumentPreviewOpenRequested } from '@/features/documentPreview/documentPreviewEvents.js'
import { isRenderable } from '@/features/documentPreview/renderableArtifact.js'
import { buildAetherResponseBlocks } from './aetherResponseBlocks.js'
import { buildHtmlArtifactFromProject } from './aetherProjectPreviewArtifact.js'
import {
  buildHtmlArtifactFromFiles,
  buildProjectFileBlocks,
} from './aetherProjectArtifact.js'

function codeBlockForFile(file) {
  const language = file.path.endsWith('.html') ? 'html' : file.path.split('.').pop() || 'text'
  return {
    type: 'code',
    language,
    content: file.content,
  }
}

export function buildAetherBlocks(text, filesMap, project) {
  const files = Array.from(filesMap.values())
  const artifact = buildHtmlArtifactFromProject(project, files) || buildHtmlArtifactFromFiles(files)
  const blocks = [
    ...(buildAetherResponseBlocks(text) || []),
    ...buildProjectFileBlocks(files, artifact, project),
    ...(project ? [] : files.slice(0, 3).map(codeBlockForFile)),
  ]
  if (isRenderable(artifact)) setTimeout(() => emitDocumentPreviewOpenRequested(artifact), 0)
  return blocks.length ? blocks : null
}
